import React from 'react';
import teslaTop from '../../../images/teslaTop.png';

const TeslaTop = (landing, pro) => (
  <div className="toronto-vehicle-types__pro">
    <img
      className="toronto-vehicle-types__car-image toronto-vehicle-types__car-image--bmw"
      src={teslaTop}
      alt=""
    />
  </div>
);

export default TeslaTop;



// WEBPACK FOOTER //
// ./src/components/Static/UberToronto/TeslaTop.js